import * as React from 'react';

import { SanitizeHTML } from 'app/utils/htmlSanitizer';

type Elements = Extract<
  keyof HTMLElementTagNameMap,
  keyof JSX.IntrinsicElements
>;

type SafeInnerHTMLSetterProps<T extends Elements> = JSX.IntrinsicElements[T] & {
  /** The HTML element to use */
  element: T;
  /** The HTML string to sanitize and use in the Element */
  content: string;
  /** The sanitization profile to use (defaults to 'default') */
  profile?: keyof typeof SanitizeHTML.profiles;
  /** Skip sanitizing */
  noSanitize?: boolean;
  /** A ref to the element that will be mounted to the DOM */
  innerRef?: React.Ref<HTMLElement>;
};

export const SafeInnerHtmlSetter = <T extends Elements>({
  element,
  content,
  profile,
  noSanitize,
  innerRef,
  ...otherProps
}: SafeInnerHTMLSetterProps<T>): JSX.Element => {
  return React.createElement(element, {
    ...otherProps,
    ref: innerRef,
    dangerouslySetInnerHTML: {
      __html: noSanitize
        ? content
        : SanitizeHTML.byProfile(content, profile || 'default'),
    },
  });
};
